<template>
	<div class="wp100 pb20" style="background-color: #F4F5FA;">
		<div class="dis-f jc-s ai-c pt20 pb10 pl20 pr20">
			<p class="fs16"><i class="fs16 sz sztougao mr5"></i>编辑投稿</p>
			<div>
				<el-button v-if="contribution.Info.to_be_modified === 1"
					style="background-color: #BA9DC0; padding: 10px 35px" class="fs14 col-fff" @click="submitForm">保存
				</el-button>
				<el-button size="small" style="background-color: #ffffff; padding: 10px 35px" class="fs14"
					@click="closeDrawer(false)">取消</el-button>
			</div>
		</div>

		<!-- 投稿信息 -->
		<div class="pl20 pr20">
			<div class="wp100 bg-c-fff p20 rad5 shadow-common">
				<div class="h30 pl10 lh30 fs16" style="border-left: 5px solid red">
					投稿信息
				</div>
				<div class="wp100 mt10 mb10" style="background-color: #e4e7ed; height: 1px"></div>

				<div class="dis-f h40 lh40 wp40">
					<div class="w130 col-gray fs14">
						投稿类型
						<span class="col-ff0000 pl5 h40 lh40">*</span>
					</div>
					<p class="fs14" style="width:calc(100% - 130px);" v-if="contribution.Info.cb_type.cbType == 1">
						高校师生</p>
					<p class="fs14" style="width:calc(100% - 130px);" v-else-if="contribution.Info.cb_type.cbType == 2">
						科研单位</p>
					<p class="fs14" style="width:calc(100% - 130px);" v-else-if="contribution.Info.cb_type.cbType == 3">
						校长教师</p>
					<p class="fs14" style="width:calc(100% - 130px);" v-else-if="contribution.Info.cb_type.cbType == 4">
						特约来稿</p>
					<p class="fs14" style="width:calc(100% - 130px);" v-else>
						其他来稿</p>
				</div>

				<div class="dis-f h40 lh40 wp40">
					<div class="col-gray w130 fs14">
						文章名<span style="color: red" class="pl5 h40 lh40">*</span>
					</div>
					<div style="width: calc(100% - 130px);">
						<p class="fs14" v-if="contribution.Info.article_title != ''">
							{{contribution.Info.article_title }}
						</p>
						<p class="fs14 col-gray" v-else>上传后自动获取</p>
					</div>
				</div>

				<div class="dis-f h40 lh40 wp40">
					<div class="w130 col-gray fs14">副标题</div>
					<el-input style="width: calc(100% - 150px);" placeholder="请输入副标题(如有)"
						v-model="contribution.Info.article_subtitle" clearable :disabled="cbId > 0">
					</el-input>
				</div>
				
				<!-- 编辑沟通 -->
				<div class="dis-f h40 lh40 wp40 pt10" v-if="contribution.Info.to_be_modified === 1">
					<div class="w130 col-gray fs14">编辑沟通</div>
					<el-input style="width: calc(100% - 150px);" placeholder="请输入编辑沟通"
						v-model="contribution.Info.communication_with_editor" clearable>
					</el-input>
				</div>
			</div>
		</div>

		<!-- 作者信息 -->
		<div class="mt20 pl20 pr20">
			<div class="rad5 bg-c-fff shadow-common p20">
				<div class="h30 pl10 lh30 fs16" style="border-left: 5px solid red">
					作者信息
				</div>
				<div class="wp100 mt10 mb10" style="background-color: #e4e7ed; height: 1px"></div>

				<div class="wp40">
					<div class="dis-f h40 lh40">
						<div class="w130 fs14 col-gray">
							第一作者姓名
							<span class="col-ff0000">*</span>
						</div>
						<el-input style="width: calc(100% - 130px);" placeholder="请输入姓名"
							v-model="contribution.AuthorList[0].author" clearable :disabled="cbId > 0">
						</el-input>
					</div>
				</div>

				<div class="dis-f pt10">
					<div class="wp40 h40 lh40">
						<div class="dis-f h40 lh40">
							<div class="w130 col-gray fs14">作者第一单位
								<span class="col-ff0000">*</span>
							</div>
							<el-input style="width: calc(100% - 130px);" placeholder="请输入单位"
								v-model="contribution.AuthorList[0].author_unit_1" clearable :disabled="cbId > 0">
							</el-input>
						</div>
					</div>
					<div class="pl40 wp40 h40 lh40">
						<div class="dis-f">
							<div class="w130 col-gray fs14">单位邮编
								<span class="col-ff0000">*</span>
							</div>
							<el-input style="width: calc(100% - 130px);" placeholder="请输入邮编"
								v-model="contribution.AuthorList[0].author_postcode_1" clearable :disabled="cbId > 0">
							</el-input>
						</div>
					</div>
				</div>

				<div class="dis-f pt10">
					<div class="wp40 h40 lh40">
						<div class="dis-f h40 lh40">
							<div class="w130 col-gray fs14">作者第二单位
							</div>
							<el-input style="width: calc(100% - 130px);" placeholder="请输入单位"
								v-model="contribution.AuthorList[0].author_unit_2" clearable :disabled="cbId > 0">
							</el-input>
						</div>
					</div>
					<div class="pl40 wp40 h40 lh40">
						<div class="dis-f">
							<div class="w130 col-gray fs14">单位邮编
							</div>
							<el-input style="width: calc(100% - 130px);" placeholder="请输入邮编"
								v-model="contribution.AuthorList[0].author_postcode_2" clearable :disabled="cbId > 0">
							</el-input>
						</div>
					</div>
				</div>


				<div class="dis-f pt20">
					<div class="wp40 h40 lh40">
						<div class="dis-f h40 lh40">
							<div class="w130 col-gray fs14">第二作者姓名
							</div>
							<el-input style="width: calc(100% - 130px);" placeholder="请输入作者姓名"
								v-model="contribution.AuthorList[1].author" clearable :disabled="cbId > 0">
							</el-input>
						</div>
					</div>
				</div>

				<div class="dis-f pt10">
					<div class="wp40 h40 lh40">
						<div class="dis-f h40 lh40">
							<div class="w130 col-gray fs14">作者第一单位
							</div>
							<el-input style="width: calc(100% - 130px);" placeholder="请输入作者单位"
								v-model="contribution.AuthorList[1].author_unit_1" clearable :disabled="cbId > 0">
							</el-input>
						</div>
					</div>
					<div class="pl40 wp40 h40 lh40">
						<div class="dis-f">
							<div class="w130 col-gray fs14">单位邮编
							</div>
							<el-input style="width: calc(100% - 130px);" placeholder="请输入单位邮编"
								v-model="contribution.AuthorList[1].author_postcode_1" clearable :disabled="cbId > 0">
							</el-input>
						</div>
					</div>
				</div>

				<div class="dis-f pt10">
					<div class="wp40 h40 lh40">
						<div class="dis-f h40 lh40">
							<div class="w130 col-gray fs14">作者第二单位
							</div>
							<el-input style="width: calc(100% - 130px);" placeholder="请输入作者单位"
								v-model="contribution.AuthorList[1].author_unit_2" clearable :disabled="cbId > 0">
							</el-input>
						</div>
					</div>
					<div class="pl40 wp40 h40 lh40">
						<div class="dis-f">
							<div class="w130 col-gray fs14">单位邮编
							</div>
							<el-input style="width: calc(100% - 130px);" placeholder="请输入单位邮编"
								v-model="contribution.AuthorList[1].author_postcode_2" clearable :disabled="cbId > 0">
							</el-input>
						</div>
					</div>
				</div>
			</div>
		</div>


		<!--稿件附件  -->
		<div class="mt20 pl20 pr20">
			<div class="wp100 bg-c-fff rad5 shadow-common p20">
				<div class="h30 pl10 lh30 fs16" style="border-left: 5px solid red">
					投稿附件
				</div>
				<div class="wp100 mt10 mb10" style="background-color: #e4e7ed; height: 1px"></div>

				<el-upload class="upload-demo pt10 pb10" ref="upload" action="" accept=".doc,.docx"
					:before-remove="beforeRemove" :auto-upload="false" :limit="1" :on-exceed="handleExceed"
					:file-list="fileList" :on-change="getFile">
					<el-button size="small" type="default"><i class="el-icon-upload pr5"></i>点击上传</el-button>
					<div slot="tip" class="el-upload__tip">
						附件支持DOC、DOCX格式 系统自动将附件名填为文章名
					</div>
				</el-upload>
			</div>
		</div>

		<!-- 联系人 -->
		<div class="mt20 pl20 pr20">
			<div class="bg-c-fff shadow-common rad5 p20">
				<div class="card-header wp100">
					<h4 class="fs16 fl h30 lh30 pl10" style="border-left: 5px solid red;">
						联系人
					</h4>
					<el-button class="fr" size="small" @click="openContact" v-if="cbId === 0">选择联系人</el-button>
					<div style="clear: both;"></div>
					<div class="wp100 mt10 mb10" style="background-color: #e4e7ed; height: 1px"></div>
				</div>

				<!-- 信息卡片 -->
				<div v-if="
				  contribution.Info.contact_info != undefined &&
				  contribution.Info.contact_info.contact_name != ''
				" class="mt10">
					<div slot="header" class="clearfix">
						<span>{{ contribution.Info.contact_info.contact_name }}</span>
						<span class="pl20">{{
				    contribution.Info.contact_info.contact_phone.phone
				  }}</span>
					</div>
					<div class="text item">
						<div class="information">
							<div class="pt10">
								{{ contribution.Info.contact_info.contact_email }}
							</div>
						</div>
						<div class="pt10">
							<span class="">
								{{ contribution.Info.contact_info.contact_province.proviceName }}
								{{ contribution.Info.contact_info.contact_city.cityName }}
								{{ contribution.Info.contact_info.contact_area.areaName }}
								{{ contribution.Info.contact_info.contact_address }}
							</span>
							<span>{{
				      contribution.Info.contact_info.contact_postcode
				    }}</span>
						</div>
					</div>
				</div>
			</div>
		</div>

		<!-- 银行账户 -->
		<div class="mt20 pl20 pr20" v-if="contribution.Info.status.cbStatus === 4">
			<div class="bg-c-fff rad5 p20 shadow-common">
				<div class="card-header wp100">
					<h4 class="fs16 fl h30 lh30 pl10" style="border-left: 5px solid red;">
						银行账户
					</h4>
					<el-button class="fr" size="small" @click="openBank">选择银行账户</el-button>
					<div style="clear: both;"></div>
					<div class="wp100 mt10 mb10" style="background-color: #e4e7ed; height: 1px"></div>
				</div>

				<!-- 信息卡片 -->
				<div v-if="contribution.Bank != undefined" class="mt10">
					<div slot="header" class="clearfix">
						<span>{{ contribution.Bank.name }}</span>
						<span>{{
				  contribution.Bank.id_card.GetIdCard
				}}</span>
					</div>
					<div class="text item">
						<div class="information">
							<div class="pt10">
								{{ contribution.Bank.account }}
							</div>
						</div>
						<div class="pt10">
							<span class="">
								{{ contribution.Bank.bank }}
							</span>
						</div>
					</div>
				</div>
			</div>
		</div>

		<my-dialog title="选择联系人" path="contribution/contact.vue" ref="chooseContact" width="700px" height="700px"
			@ok="afterChoose"></my-dialog>
		<my-dialog title="选择银行" path="contribution/bank/bank.vue" ref="chooseBankDialog" width="700px" height="700px"
			@ok="afterChooseBank"></my-dialog>
	</div>
</template>

<script>
	import {
		token
	} from "../../utils/token";
	import * as dataConfig from "../../data/config";
	export default {
		data() {
			return {
				cbId: 0,
				contribution: {
					Id: {
						Id: 0,
					},
					CurrentDoc: {
						doc_name: "",
						doc_path: "",
					},
					Info: {
						id: {
							Id: 0,
						},
						cb_type: {
							cbType: 1,
						},
						article_title: "",
						article_subtitle: "",
						major_author_id: 0,
						contact_info: {
							contact_name: "",
							contact_phone: {
								phone: "",
							},
							contact_email: "",
							contact_province: {
								proviceId: 0,
								proviceName: "",
							},
							contact_city: {
								cityId: 0,
								cityName: "",
							},
							contact_area: {
								areaId: 0,
								areaName: "",
							},
							contact_address: "",
							contact_postcode: "",
						},
						member_id: 0,
						member_name: "",
						status: {
							cbStatus: 1,
						},
					},
					AuthorList: [{
							id: 0,
							author: "",
							author_unit_1: "",
							author_unit_2: "",
							author_postcode_1: "",
							author_postcode_2: "",
						},
						{
							id: 0,
							author: "",
							author_unit_1: "",
							author_unit_2: "",
							author_postcode_1: "",
							author_postcode_2: "",
						},
					],
					DocList: [{
						id: 0,
						doc_path: "",
					}, ],
					DocFileName: "",
					DocFile: "",
				},
				typeArray: dataConfig.memberType,
				fileList: [],
			};
		},

		methods: {
			init(id) {
				this.cbId = id;
				if (id > 0) {
					this.$api.contribute
						.contributionDetail(id)
						.then((res) => {
							let {
								delAuthorList,
								...contribution
							} = res.Data;
							let {
								AuthorList: authorList
							} = this.contribution;
							if (res.Data.AuthorList.length > 1) {
								authorList = res.Data.AuthorList;
							} else {
								authorList[0] = res.Data.AuthorList[0];
							}
							this.contribution = contribution;
							this.contribution.AuthorList = authorList;
						});
				}
				
			},


			// 上传文件获取文件信息和base64加密
			getFile(file, fileList) {
				this.contribution.DocFileName = file.raw.name;
				this.contribution.Info.article_title = file.raw.name.split('.')[0];
				this.contribution.CurrentDoc.doc_name = file.raw.name;
				var extension = file.raw.name.substring(file.raw.name.lastIndexOf('.')).toLocaleLowerCase();
				let allowExts = [".doc", ".docx", ".pdf"];
				if (!allowExts.includes(extension)) {
					this.$message.warning("请上传word或pdf文件");
					return;
				}
				this.getBase64(file.raw).then((res) => {
					// 这里是Base64结果
					this.contribution.DocFile = res.split(",")[1];
				});
			},


			getBase64(file) {
				return new Promise(function(resolve, reject) {
					let reader = new FileReader();
					let imgResult = "";
					reader.readAsDataURL(file);
					reader.onload = function() {
						imgResult = reader.result;
					};
					reader.onerror = function(error) {
						reject(error);
					};
					reader.onloadend = function() {
						resolve(imgResult);
					};
				});
			},


			// 删除上传的文件
			beforeRemove(file, fileList) {
				this.$confirm(`确定移除 ${file.name}？`).then(() => {
					this.contribution.DocFileName = "";
					this.contribution.DocFile = "";
					this.contribution.Info.article_title = "";
					this.fileList = [];
					return true;
				});
				return false;
			},

			// 选择的文件超出限制范围
			handleExceed(files, fileList) {
				this.$message.warning(`超出文章选择上限`);
			},

			// 保存提交数据
			submitForm() {
				if (this.contribution.Info.cb_type == undefined) {
					this.alertError("请选择投稿类型");
					return;
				} else if (this.contribution.AuthorList[0].author == "") {
					this.alertError("请填写第一作者");
					return;
				} else if (this.contribution.AuthorList[0].author_unit_1 == "") {
					this.alertError("请填写第一作者单位");
					return;
				} else if (this.contribution.AuthorList[0].author_postcode_1 == "") {
					this.alertError("请填写单位邮编");
					return;
				} else if (this.contribution.DocFileName == "") {
					this.alertError("请上传投稿文件");
					return;
				} else if (this.contribution.Info.contact_info.contact_name.trim() == "") {
					this.alertError("请选择联系人");
					return;
				}
				
				// 需要修改的投稿进行提交,把是否修改过字段改成1;为了管理后台展示区分
				if(this.contribution.DocFile != "" && this.contribution.Info.to_be_modified == 1){
				      this.contribution.Info.finish_alter = 1;
				    }else{
				      this.contribution.Info.finish_alter = 0;
				    }

				this.$api.contribute
					.contributionSubmit(this.contribution)
					.then((res) => {
						if (res.Status == 2) {
							this.alertError(`${res.Data.Warn},请检查后再提交`);
						} else {
							this.alertSuccess("提交成功");
							this.closeDrawer(true);
						}
					})
					.catch((err) => {
						this.alertError(err.Data);
					});
			},


			// 打开编辑、添加联系人的弹层
			openContact() {
				this.$refs.chooseContact.show();
			},


			// 选择了会员联系方式的回调数据
			afterChoose(chooseContact) {
				this.contribution.Info.contact_info.contact_name = chooseContact.name;
				this.contribution.Info.contact_info.contact_phone.phone =
					chooseContact.phone;
				this.contribution.Info.contact_info.contact_email = chooseContact.email;
				this.contribution.Info.contact_info.contact_province.proviceId =
					chooseContact.provice_id;
				this.contribution.Info.contact_info.contact_province.proviceName =
					chooseContact.provice_name;
				this.contribution.Info.contact_info.contact_city.cityId =
					chooseContact.city_id;
				this.contribution.Info.contact_info.contact_city.cityName =
					chooseContact.city_name;
				this.contribution.Info.contact_info.contact_area.areaId =
					chooseContact.areas_id;
				this.contribution.Info.contact_info.contact_area.areaName =
					chooseContact.areas_name;
				this.contribution.Info.contact_info.contact_address =
					chooseContact.address;
				this.contribution.Info.contact_info.contact_postcode =
					chooseContact.postcode;
			},


			// 打开编辑、添加联系人的弹层
			openBank() {
				this.$refs.chooseBankDialog.show();
			},


			// 选择了会员联系方式的回调数据
			afterChooseBank(chooseBank) {
				console.log("选择的银行", chooseBank);
				// let confirmBankData = {
				//   "member_bank_id": chooseBank.id,
				//   "name": chooseBank.name,
				//   "account": chooseBank.account,
				//   "id_card": {
				//     "idCardNo": chooseBank.id_card
				//   },
				//   "bank": chooseBank.bank,
				//   "ContributionId": this.contribution.Id.id,
				// }
				let confirmBankData = Object.assign({}, chooseBank);
				confirmBankData.id_card = {
					"GetIdCard": chooseBank.id_card
				};
				confirmBankData.member_bank_id = chooseBank.id;
				confirmBankData.ContributionId = this.contribution.Id.id;
				this.$api.contribute
					.confirmBank(confirmBankData)
					.then((res) => {
						this.contribution.Bank = confirmBankData;
					})
					.catch((err) => {
						this.alertError(err.Data);
					});
			},

			// 关闭抽屉
			// reSearch是不是要重新更新数据
			closeDrawer(reSearch) {
				this.$emit("editCallback", reSearch);
				this.$emit("hide");
			},
		},

		// watch: {
		// 	type(newVal, oldVal) {
		// 		this.memberList = [];
		// 		let optionalMemberList = this.allMembers.filter(
		// 			(x, index, array) => x.type == newVal
		// 		);
		// 		this.memberList = optionalMemberList;
		// 	},

		// 	memberId(newVal, oldVal) {
		// 		console.log("memberId", this.allMembers);
		// 		this.contribution.Info.member_name = this.allMembers.Find(
		// 			(x) => x.id == newVal
		// 		).name;
		// 	},
		// },
	};
</script>


<style lang="scss" scoped>
	.body {
		padding: 20px 200px;
	}

	.bodys {
		padding: 20px 600px;
	}

	.body-l {
		width: 40%;
		border: 1px solid #efefef;
		// padding: 10px;
		margin: 40px;
	}

	.body-r {
		width: 40%;
		border: 1px solid #efefef;
		margin: 40px;
	}

	.el-input {
		width: 40%;
	}

	.btns {
		margin: 0 auto;
		padding: 40rpx;
		background: #5084f3;
		background-color: #5084f3;
		color: #fff;
		box-shadow: 0 1px 10rpx 1rpx rgba(0, 0, 0, 0.1);
	}

	.text {
		font-size: 14px;
	}

	.item {
		margin-bottom: 18px;
	}

	.clearfix:before,
	.clearfix:after {
		display: table;
		content: "";
	}

	.clearfix:after {
		clear: both;
	}

	.box-card {
		width: 450px;
	}

	.bor {
		border: 10px solid #15d8cb;
	}

	.pannel-title {
		height: 20px;
		line-height: 20px;
		padding-left: 10px;
		font-weight: bold;
	}

	.storeEdit-title-line {
		width: 5px;
		height: 20px;
		background-color: #f93e61;
		margin-right: 10px;
	}
</style>
